import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { AlertCircle, CheckCircle2 } from "lucide-react";
import { AuthDialogProps } from "../@types/props.types";

const AuthDialog = ({ isOpen, onOpenChange, message, onClose }: AuthDialogProps) => {
  const isSuccess = message === "Вы успешно авторизовались";

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[425px]"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="flex flex-col items-center gap-2">
          <div className={`rounded-full p-3 ${isSuccess ? "bg-green-50" : "bg-red-50"}`}>
            {isSuccess ? (
              <CheckCircle2 className="h-6 w-6 text-green-500" />
            ) : (
              <AlertCircle className="h-6 w-6 text-red-500" />
            )}
          </div>
          <DialogTitle className="text-xl">{isSuccess ? "Успешно" : "Ошибка"}</DialogTitle>
          <DialogDescription className="text-center text-gray-500">{message}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-4">
          <Button
            onClick={onClose}
            className={`w-full ${isSuccess ? "bg-green-500 hover:bg-green-600" : "bg-red-500 hover:bg-red-600"}`}
          >
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AuthDialog;
